import accessDeniedErrorTemplate from "./accessDeniedErrorTemplate";
import csrfAccessDeniedErrorTemplate from "./csrfAccessDeniedErrorTemplate";
import customErrorTemplate from "./customErrorTemplate";
import errorTemplate from "./errorTemplate";
import moneySourcesVaryTemplate from "./moneySourcesVaryTemplate";
import notAccountBasedTemplate from "./notAccountBasedTemplate";
import transferRestrictionErrorTemplate from "./transferRestrictionErrorTemplate";

var routeStates = function ($stateProvider) {
    $stateProvider

        // Account Selection View =================================
        .state("genericError", {
            url: "/generic-error",
            template: errorTemplate,
            controller: "errorController"
        })

        .state("moneySourcesVary", {
            url: "/moneySourcesVary",
            template: moneySourcesVaryTemplate,
            controller: "errorController",
            params: {
                changeTitle: "false"
            }
        })

        .state("csrfAccessDeniedError", {
            url: "/securityAccessDeniedError/:errorCode",
            template: csrfAccessDeniedErrorTemplate,
            controller: "errorController"
        })

        .state("accessDeniedError", {
            url: "/accessDeniedError/:errorCode",
            template: accessDeniedErrorTemplate,
            controller: "errorController"
        })

        .state("notAccountBased", {
            url: "/not-account-based",
            template: notAccountBasedTemplate,
            controller: "errorController"
        })

        .state("transferRestrictionError", {
            url: "/restriction",
            template: transferRestrictionErrorTemplate,
            controller: "errorController"
        })

        .state("customError", {
            url: "/custom-error",
            template: customErrorTemplate,
            controller: "errorController",
            params: {
                enableCustomError: "true",
                customTitleKey: "error.genericTransactionError.headingTitle",
                customMessageKey: "error.genericTransactionError.errorMessage"
            }
        });
};

routeStates.$inject = ["$stateProvider"];
export default routeStates;
